export default "__VITE_ASSET__ff19c9b7__"